import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';
import { IRadiantamento } from '../../../shared/services/api/AdiantamentoService';

async function RelatorioAdiantamento(dados: IRadiantamento[], checked: boolean, texto: string) {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  const Total = dados.reduce((acc, item) => acc + (item.valor || 0), 0);

  const rows = dados.map((row) => {
    return [
      {text: moment(row.datadesconto).format('DD/MM/YYYY'), alignment: 'center',  fontSize: 9},
      {text: row.nome, alignment: 'left',  fontSize: 9},
      {text: row.historico, alignment: 'left',  fontSize: 9},
      {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(row.valor), alignment: 'right', fontSize: 9},
    ]; 
  });  

  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function () {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Erro ao obter o contexto 2D');
          return;
        }
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      };
      img.onerror = function () {
        reject(`Erro ao carregar a imagem: ${url}`);
      };
      img.src = url;
    });
  }


  const imageUrl = './logo.png';
  const imageData = await getBase64ImageFromUrl(imageUrl);

  const documentDefinition: any = {
    pageSize: 'A4',
    pageMargins: [20, 10, 20, 10],
    pageOrientation: 'portrait',
    header: { 
        columns: [
            { text: ' sifcolheita', alignment: 'left', fontSize: 5 },
            { text: moment().format('DD/MM/YYYY HH:mm'), margin: [10, 0, 10, 0], alignment: 'right', fontSize: 8 },
          ],
     },
     content: [
      {  
        table: {
          widths: [20, '*'],
          body: [
            [
              { image: imageData, width: 30,
                margin: [0, 15, 0, 0],
                border: [false, false, false, false],
              },
              {
                text: 'Relatório de Adiantamento',
                fontSize: 20,  
                bold: true,
                alignment: 'center',
                border: [false, false, false, true],
                margin: [0, 15, 0, 0],
                borderColor: ['#000000', '#000000', '#000000', '#005e1f'], 
                borderWidth: [0, 0, 0, 2] 
              },
            ],
          ],
        },
      },
      {
        text: texto,
        margin: [0, 15, 0, 0],
      },
      {  
        table: {
          widths: [60, 180, 220, 50],
          body: [
            [
              { text: 'Data Desconto', alignment: 'center', fillColor: '#dddddd', fontSize: 9, bold: true },
              { text: 'Colhedor', alignment: 'left', fillColor: '#dddddd', fontSize: 9, bold: true },
              { text: 'Histórico', alignment: 'left', fillColor: '#dddddd', fontSize: 9, bold: true },
              { text: 'Valor', alignment: 'right', fillColor: '#dddddd', fontSize: 9, bold: true },
            ],
            ...rows,
            [
              {text: (checked ? 'Descontar' : 'Descontado'), fillColor: '#dddddd', alignment: 'center', bold: true, fontSize: 10},
              { text: 'Total Geral:', colSpan: 2, alignment: 'right', bold: true, fontSize: 8 },
              {},
              {
                text: new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(Total),
                alignment: 'right',
                fontSize: 8,
                bold: true,
              },
            ],
          ],
        },
      },
    ],
  };

  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
  pdfDocGenerator.open();
}

export default RelatorioAdiantamento;